import chinaFlag from '@/assets/images/flag/china.webp';
import card1Image from '@/assets/images/flag/card1.webp';
import card6Image from '@/assets/images/flag/card6.webp';
import card7Image from '@/assets/images/flag/card7.webp';
import dubaiFlag from '@/assets/images/flag/dubai.webp';
import gashty15Shaw from '@/assets/images/flag/gashty-15-shaw.webp';
import medinaFlag from '@/assets/images/flag/medina.webp';

export type PackageItem = {
  sectionId: string;
  order: string;
  category: string;
  name: string;
  summary: string;
  description: string[];
  tags: string[];
  note?: string;
  featured?: boolean;
  image?: string;
  background: string;
  href: string;
  hasDetailPage: boolean;
  detailPage?: {
    eyebrow?: string;
    intro?: string;
    heroStats?: Array<{
      label: string;
      value: string;
    }>;
    highlights?: Array<{
      title: string;
      description: string;
    }>;
    cities?: Array<{
      name: string;
      note: string;
    }>;
    included?: string[];
    bonuses?: string[];
    whyThisTrip?: {
      title: string;
      paragraphs: string[];
    };
    specialOffer?: {
      title: string;
      subtitle?: string;
      items: string[];
      footnote?: string;
    };
    fairOverview?: {
      title: string;
      intro: string;
      stats: Array<{
        label: string;
        value: string;
      }>;
      note: string;
    };
    guidedSupport?: {
      title: string;
      problems: string[];
      solution: string;
    };
    learning?: {
      title: string;
      intro: string;
      items?: string[];
      modules?: Array<{
        id: string;
        title: string;
        subtitle: string;
        description: string;
      }>;
      closing?: string;
    };
    closingNote?: string;
  };
};

export const packagesData: PackageItem[] = [
  {
    sectionId: 'welcome-section',
    order: '',
    category: 'دەستپێک',
    name: 'بەخێربێن بۆ بونیادنانی سەرکردەکانی سبەینێ',
    summary: 'بە چوار گەشتی ناوازە و دوو پاکێجی خوولی بزنس، هەموو ژیانت بگۆڕە لە ڕووی دین و دونیاکەتەوە.',
    description: [
      'هەنگاو بنێ و ئامانجەکەت دیاری بکەیت، ئامادەکاری بۆ بکەیت و لە هەوڵدان نەوەستیت تا دەگیتە ئامانجەکەت.',
      'ڕاهێنانی کارگێڕی و پشتیوانی لە گەیشتن بە ئامانجەکانت لەگەڵ دیدگایەک کە دین و دونیا پێکەوە دەبینێت.',
      'لەسەر فەرمایشتی پێغەمبەری خودا و کلامی اللە، ئامانجمان ئەوەیە لە دونیادا ببیتە سەرکردە و لە قیامەتیش لە سەرکەوتووان بیت.',
    ],
    tags: ['سەرکردایەتی', 'ئامانج', 'پشتیوانی'],
    note:
      'بە چوار گەشتی ناوازە و دوو پاکێجی خوولی بزنس، هەموو ژیانت بگۆڕە لە ڕووی دین و دونیاکەتەوە.',
    featured: true,
    image: card1Image,
    background: '',
    href: '/#welcome-section',
    hasDetailPage: false,
  },
  {
    sectionId: 'china-trip-section',
    order: '01',
    category: 'گەشتی بازرگانی',
    name: 'پلانی گەشتی بازرگانی وڵاتی چین',
    summary:
      'گەشتێکی 10 ڕۆژەی تایبەت بۆ پێشانگای کانتۆن و چوار شاری بازرگانی چین، بۆ ئەوەی کاڵا بدۆزیتەوە، پەیوەندی ڕاستەوخۆ دروست بکەیت و بە پلانێکی کرداری بگەڕێیتەوە.',
    description: [
      'لە مانگی 11ی 2027 دا، بەشداری گەشتێکی بازرگانی تایبەت بکە بۆ وڵاتی چین؛ گەشتێک کە تەنها گەڕان نییە، بەڵکو دەرفەتێکی ڕاستەوخۆی کار و فێربوونە.',
      'لە بازنەی سنووردارکراوی خۆت دەردەچیت، شاری بازرگانی و کارگە گەورەکان دەبینیت و فێر دەبیت چۆن بە شێوەیەکی دروست کاڵا، هاوبەش و بازاڕی گونجاو بدۆزیتەوە.',
      'ئەم گەشتە لەگەڵ ڕێنمایی بازرگانی و وانەی تایبەت لە بابەتی معامەلات و بزنس لە ئیسلامدا پێک هاتووە، بۆ ئەوەی بە سوود و بە ئارامی بگەڕێیتەوە.',
    ],
    tags: ['چین', 'کانتۆن فێر', '4 شار', 'بازرگانی', 'بزنس'],
    note:
      'لە 18 بۆ 27ی مانگی 11، لەگەڵ تیمێکی ئەزمووندار دەچیت بۆ Guangzhou و Shenzhen و Foshan و Chongqing بۆ سەردانی بازار، کارگە و پێشانگای کانتۆن Phase 1 & 2 لە چوارچێوەیەکی پارێزراودا.',
    image: chinaFlag,
    background: '',
    href: '/gashti-chin',
    hasDetailPage: true,
    detailPage: {
      eyebrow: 'China Business Trip 2027',
      intro:
        'ئەگەر دەتەوێت بیرۆکەکانت بگوازیتەوە بۆ ئاستی پرۆفیشناڵ، ئەم گەشتە بۆ تۆ دروستکراوە. لێرەدا تەنها بە سەیرکردن ناوەستیت؛ بەڵکو ڕاستەوخۆ دەچیتە ناو بازاڕ، پێشانگا و ژینگەی بازرگانیی چین.',
      heroStats: [
        { label: 'بەروار', value: '18-27 / 11 / 2027' },
        { label: 'ماوە', value: '10 ڕۆژ' },
        { label: 'شارەکان', value: '4 شاری بازرگانی' },
        { label: 'پێشانگا', value: 'Canton Fair 1 & 2' },
        { label: 'سەرپەرشتی', value: '+8 ساڵ ئەزموون' },
      ],
      highlights: [
        {
          title: 'گەشتێک بۆ کار، نەک تەنها گەڕان',
          description:
            'بە شێوەیەکی ڕاستەوخۆ دەچیتە ناو بازاڕ و کارگەکان بۆ ئەوەی براند، کاڵا و ڕێگەی هاوردەکردن بە چاوی خۆت ببینیت.',
        },
        {
          title: 'فێربوونی فیقهی بازرگانی',
          description:
            'هەموو بابەتە گرنگەکانی معامەلات و بازرگانی لە چوارچێوەی شەرعیدا باس دەکرێن تا بزانیت چۆن بە پاراستنی دینەکەت کار بکەیت.',
        },
        {
          title: 'تۆڕسازی لەگەڵ پیشەسازان',
          description:
            'لەگەڵ کارگێڕ، بازرگان و بەرپرسانی شوێنەکان پەیوەندی دروست دەکەیت بۆ ئەوەی دوای گەشتیش دەروازەکان بۆت کراوە بمێننەوە.',
        },
        {
          title: 'ڕاهێنانی بزنس و بیرکردنەوەی کرداری',
          description:
            'لە ماوەی گەشتەکەدا چەند وەشانی ڕاهێنان، ڕێکخستن و پرسیار-وەڵام بۆت دابین دەکرێت تا هەر شتێک ببینیت بە کردار بیکەیت.',
        },
      ],
      cities: [
        {
          name: 'Guangzhou',
          note: 'ناوەندی پێشانگا و بازاڕە گەورەکانی هاوردە و هەناردە.',
        },
        {
          name: 'Shenzhen',
          note: 'شارێکی پڕ لە تێکنەلۆجیا، فابریکە و نوێکارییە بازرگانییەکان.',
        },
        {
          name: 'Foshan',
          note: 'ناسراو بە کارگە و فرۆشگاکانی پێداویستی ماڵ و ماددەی پیشەسازی.',
        },
        {
          name: 'Chongqing',
          note: 'شوێنێکی گرنگ بۆ فراوانکردنی تێڕوانینت لە بازاڕ و زنجیرەی دابینکردن.',
        },
      ],
      included: [
        'سەردانی پێشانگای کانتۆن Phase 1 & 2.',
        'ڕێنمایی و سەرپەرشتی لەلایەن تیمێک بە ئەزموونی زیاتر لە 8 ساڵ لە چین.',
        'کارتی چوونە ژوورەوە و هۆکاری گواستنەوە بۆ پێشانگاکان بە خۆڕایی.',
        'فێربوونی "کتێبی مامەڵە" و بابەتە فیقهییەکانی بازرگانی.',
        'کۆڕبەندی تایبەت بە بزنس لە ئیسلامدا لەلایەن م. ئەرکان و د. شکار.',
      ],
      bonuses: [
        'ڕاهێنانی "بزنس سەلام" بە خۆڕایی وەک شێوازێکی 100% حەلال بۆ فرۆشتنی ئۆنلاین بەبێ ستۆک.',
        'ڕاهێنانی تۆڕە کۆمەڵایەتییەکان و ستراتیژی مارکێتینگ بە خۆڕایی.',
        'مانەوەی گروپی پشتیوانی دوای گەڕانەوە بۆ ئەوەی لەگەڵت بمێنینەوە تا دەستپێکردن و سەرکەوتن.',
      ],
      whyThisTrip: {
        title: 'بۆچی ئەم گەشتە ئەنجام بدەیت؟',
        paragraphs: [
          'ئەم گەشتەی 10 ڕۆژە پێش هەموو شتێک ئەزموونێکی مرۆیی نایابە پێت دەبەخشێت لە ژینگەیەکی پارێزراودا لەگەڵ کۆمەڵێک بەشداربووی هەڵبژێردراو کە هەموویان بە نیازی گۆڕان و گەشەپێدان دێن.',
          'کاتێک لە ناوچەی سنووردارکراوی خۆت دەردەچیت و شتێک دەکەیت کە زۆربەی خەڵک نەیان توانیوە بگەن پێی، تۆ بە گۆڕانێکی گەورە لە ڕووی تێڕوانین، بڕیار و متمانە بە خۆ گەڕێیتەوە.',
          'تۆ پێش ئەو کەسانە دەکەویت کە هێشتا بزنسە نوێ و کاڵای هەڵبژێردراویان نەدۆزیوەتەوە؛ پەیوەندی ڕاستەوخۆ لەگەڵ کارگەکان دروست دەکەیت و بە پلانێکی کرداریی ڕوون بگەڕێیتەوە بۆ بنیاتنانی بزنسەکەت.',
        ],
      },
      specialOffer: {
        title: 'دیاریی تایبەت بۆ یەکەم تۆماربووان',
        subtitle: 'تەنها بۆ 10 کەسی یەکەمی تۆمارکراو',
        items: [
          'بۆ 10 کەسی یەکەم 200$ دەگەڕێندرێتەوە بۆیان.',
          'ئەم دەرفەتە لەگەڵ تۆماربوونی کەسی 11هەم کۆتایی دێت.',
          'تەنها بە ناوی تۆماربوونت لە "گەشتی ئەزموونی چین" ڕاهێنانی "بزنس سەلام" بە خۆڕایی وەردەگریت.',
        ],
        footnote:
          'بزنس سەلام شێوازێکی تەواوی حەلالە بۆ فرۆشتنی ئۆنلاین بەبێ ستۆک، ئامادەکراو لەلایەن شارەزای سۆشیاڵ میدیا کاک سەرکار و شارەزای بزنس ئەرکان کریم، پشتبەستوو بە گرێبەستی Salam کە لە سەردەمی پێغەمبەر ﷺەوە پەیڕەو کراوە.',
      },
      fairOverview: {
        title: 'Canton Fair: دڵی بازرگانی چین',
        intro:
          '140هەمین گەورەترین پێشانگای بازرگانی لە جیهاندا، لە Guangzhou لە ساڵی 1957ەوە بەڕێوە دەچێت و گەورەترین کارگە، کۆمپانیا و بەرهەمهێنەرانی چین لە ژێر یەک سەقفدا کۆدەکاتەوە.',
        stats: [
          { label: 'کارگە و کۆمپانیا', value: '26,000+' },
          { label: 'کڕیار', value: '200,000+' },
          { label: 'وڵات', value: '200+' },
          { label: 'قەبارەی فرۆشتن', value: '1.2T$' },
        ],
        note:
          'ئێمە هەموو کارئاسانییەک دەکەین: کارتی چوونە ژوورەوە، هۆکاری گواستنەوە و ڕێکخستنی هەموو پێویستییەکانی ناو پێشانگاکان بە شێوەیەکی ئاسان و ڕێکخراو دابین دەکرێت.',
      },
      guidedSupport: {
        title: 'چۆن ئەم گەشتە لە ئاڵۆزی دەتپارێزێت؟',
        problems: [
          'قەبارەی پێشانگا زۆر گەورەیە و بە تەنها وونبوون زۆر ئاسانە.',
          'دەیان هەزار پێشانگا و کۆمپانیا، زۆربەیان بە زمانی چینی و دانوستانیی ئاڵۆز.',
          'مەترسی فێڵ، ساختەکاری و هەڵبژاردنی هەڵەی دابینکەر هەیە.',
          'زۆر کەس بە دەستی بەتاڵ، دڵسارد و بێ پلانی ڕوون دەگەڕێنەوە.',
        ],
        solution:
          'چیرۆکەکە لەگەڵ ئێمە تەواو جیاوازە. ئێمە دەزانین ڕێک بۆ کوێ بچین، کێ ببینین، چۆن دانوستان بکەین و چۆن لە فێڵەکان دوور بکەوینەوە. لەگەڵ تیم و سەرپەرشتی کەسێک دەڕۆیت کە زیاتر لە 8 ساڵە لەم پرۆسەیەدا ئەزموونی مەیدانی هەیە و هەروەها هاوکارییەکی فراوانی لە ناو پێشانگاکاندا هەیە.',
      },
      learning: {
        title: 'ئەوەی تۆ لەم مەیدانەدا فێری دەبیت',
        intro:
          'پێویست ناکات دوو دەفتەر دۆلارت هەبێت بۆ هێنانەوەی کۆنتێنەرێک. زۆر کەس وا دەزانن بەردەوام بڕێکی زۆر سەرمایە پێویستە، بەڵام ڕاستییەکە ئەوەیە کە کاتێک لە شوێنەکەیت، دەتوانیت بە چەند هەزار دۆلارێک یان تەنانەت کەمتر وەبەرهێنان بکەیت.',
        modules: [
          {
            id: '01',
            title: 'فرۆشتن پێش دابینکردن',
            subtitle: 'بە سەرمایەی کەمتر دەست پێ بکە',
            description:
              'فێری بنەما و مەرجەکانی Salam / Pre-Order دەبیت؛ چۆن پێش ئەوەی سەرمایەیەکی گەورە بخەیتە کاڵاوە، داواکاری بازاڕ دروست بکەیت و بە شێوازێکی شەرعی و دروست کاروبار بکەیت.',
          },
          {
            id: '02',
            title: 'تاقیکردنەوە پێش سەرمایەگوزاری',
            subtitle: 'سەرەتا بازاڕ تاقی بکەرەوە، پاشان گەورە ببە',
            description:
              'فێردەبیت چۆن بە بڕێکی کەم دەست پێ بکەیت، Sample و داواکاری بازاڕ تاقی بکەیتەوە و تەنها کاتێک سەرمایەکەت زیاد بکەیت کە دڵنیابوویت لە توانای فرۆشتنی کاڵاکەت.',
          },
          {
            id: '03',
            title: 'Sourcing ـی پیشەیی',
            subtitle: 'ڕاستەوخۆ بگەڕێ بۆ سەرچاوە',
            description:
              'لە ناو بازاڕ و کارگەکانی چین فێردەبیت چۆن Supplier و Factory ـی گونجاو بدۆزیتەوە، نرخ دانوستاندن بکەیت، کوالێتی بپشکنیت و بە کەمترین تێچوو باشترین سەرچاوە بۆ بازرگانییەکەت بدۆزیتەوە.',
          },
        ],
        closing:
          'ئامانجمان تەنها بردنت بۆ چین نییە؛ ئامانجمان ئەوەیە کاتێک دەگەڕێیتەوە، بزانیت چی بکڕیت، لە کوێ بیکڕیت و چۆن بیفرۆشیت. خەڵک پارە دەدەن بۆ ڕاهێنان تا فێر بن چۆن پارەکانیان پاشەکەوت بکەن، نەک بێسوود خەرجیان بکەن. ڕێک ئەوەیە کە لێرە فێری دەبیت.',
      },
      closingNote:
        'ئامانج تەنها سەردانی چین نییە؛ ئامانج ئەوەیە بە متمانە، تێگەیشتن، پەیوەندییەکی ڕاستەوخۆ و بنەمایەکی حەلال بگەڕێیتەوە بۆ ئەوەی بزنسەکەت بە شێوەیەکی دروست و بەبەرەکەت بنیات بنێیت.',
    },
  },
  {
    sectionId: 'dubai-trip-section',
    order: '02',
    category: 'گەشتی بازرگانی',
    name: 'گەشتی دوبەی بۆ بازرگانی',
    summary:
      'نوقمبوونێکی تەواو بازرگانی بۆ وەرگرتنی ئەزمونی ئەقارات و بازرگانی جوملە.',
    description: [
      'بەشداری بکە لە مانەوەیەکی تایبەت لەگەڵ تیمی قیام گروپ بۆ مانەوە لە شوێنێکی 5 ئەستێرە و ناسینی شوێنی ستراتیژی بازرگانی.',
      'سەردانی کۆگاکانی جوملە بکە لەگەڵماندا و فێربە چۆنیەتی هێنانەوەی هەموو جۆرە کاڵایەک و خستنەبازاڕی براندەکەت.',
      'سوودمەند ببە لە ڕاهێنانی گشتگیر لە مارکێتینگ و سۆشیال میدیا و پاکێجی بزنس سەلام و ڕاهێنانی کارگێڕی بزنس بە خۆڕایی دوای گەشتەکە.',
    ],
    tags: ['دوبەی', 'ئەقارات', 'جوملە'],
    image: dubaiFlag,
    background: '',
    href: '/gashti-dubai',
    hasDetailPage: true,
  },
  {
    sectionId: 'medina-trip-section',
    order: '03',
    category: 'گەشتی روحی',
    name: 'گەشتی 3 مانگی لە مەدینە',
    summary: 'لە شوێنێکی ئیلهام‌بەخشدا بژی و مانایەکی نوێ بە ژیانت ببەخشە.',
    description: [
      'دەرفەتێکی نوێ بۆ فێربوون و گۆڕانکاری و بەرەو ئامانجەکانی ژیانت هەنگاو نان.',
      'پاکێجێکی ناوازەیە بۆ پێشکەوتن لە دینەکەتدا و خۆئامادەکردن بۆ گەیشتن بە ئامانجەکەت.',
      'لە فەزڵی خوداوە، ئێمە تاکە کەسین کە پاکێجێکی تەواو لەم شێوەیە پێشکەش دەکەین و ڕوح و فێربوون پێکەوە دەهێنین.',
    ],
    tags: ['مەدینە', '3 مانگ', 'فێربوون'],
    image: medinaFlag,
    background: '',
    href: '/gashti-medina',
    hasDetailPage: true,
  },
  {
    sectionId: 'brothers-trip-section',
    order: '04',
    category: 'گەشتی تایبەت',
    name: 'گەشتی 15 شەوی برایان',
    summary: 'ئەزموونی عومرەیەکی تایبەت بکە لە مەدینە و مەککە.',
    description: [
      '8 شەو لە ڤێلایەکی تایبەت لە مەدینەی پیرۆز و 7 شەو لە ڤێلایەکی تایبەت لە مەککە.',
      'لەو 15 ڕۆژەدا تەواوی سیرەی پێغەمبەری خودا، بابەتی فیقیه، بیروباوەڕی دروست و تەجوید فێر دەبن.',
    ],
    tags: ['عومرە', 'مەککە', 'مەدینە'],
    image: gashty15Shaw,
    background: '',
    href: '/gashti-15-shaw',
    hasDetailPage: true,
  },
  {
    sectionId: 'business-islam-package-section',
    order: '05',
    category: 'پاکێجی بزنس',
    name: 'پاکێجی بزنس و ئیسلام',
    summary: 'ڕاهێنانی کارگێڕی بۆ بەدەستهێنانی سەرمایەی خۆت لە 0 دۆلارەوە.',
    description: [
      'بەرنامەیەکی ڕاهێنانی ناوازە بۆ فێربوونی چۆنیەتی بەدەستهێنانی سەرمایەی خۆت و دەستپێکردنی بازرگانی بە بنەمای ڕوون.',
      'بونیادنانی گەنجی موسڵمان بۆ زیاتر هاندانیان تا بتوانن سەرمایەی خۆیان هەبێت و دەست بکەن بە بازرگانییەکی سەرکەوتوو.',
    ],
    tags: ['0 دۆلار', 'سەرمایە', 'کارگێڕی'],
    image: card6Image,
    background: '',
    href: '/package-business-islam',
    hasDetailPage: true,
  },
  {
    sectionId: 'business-salam-package-section',
    order: '06',
    category: 'پاکێجی بزنس',
    name: 'پاکێجی بزنس سەلام',
    summary: 'حەرەم 100% حەڵاڵ و شێوازی فرۆشتنی ئۆنلاین بەبێ ستۆک.',
    description: [
      'بزنس سەلام ڕێگەت پێدەدات لە 100$ ـەوە دەست پێ بکەیت و بە شێوەی ئۆنلاین بفرۆشیت، بەبێ ستۆک و بە ڕێزگرتن لە بنەما ئیسلامییەکان.',
      'تەنانەت لە سفریشەوە دەتوانیت دەست بە کارەکەت بکەیت و تووشی حەرام نەبیت.',
      'بە یارمەتی خودا پاشان ئێمە هاوکارت دەبین تا هەم لە دونیا سەرکەوتوو بیت هەم لە قیامەت، و ئەو سەرمایەی دەستت دەکەوێت بە تەواوی حەڵاڵ و بەرەکەتدار بێت.',
    ],
    tags: ['100% حەڵاڵ', 'ئۆنلاین', '100$'],
    note:
      'بە یارمەتی خودا پاشان ئێمە هاوکارت دەبین تا هەم لە دونیا سەرکەوتوو بیت هەم لە قیامەت، و ئەو سەرمایەی دەستت دەکەوێت بە تەواوی حەڵاڵ و بەرەکەتدار بێت.',
    image: card7Image,
    background: '',
    href: '/package-business-salam',
    hasDetailPage: true,
  },
];

export const routePackages = packagesData.filter((item) => item.hasDetailPage);

export const findPackageByHref = (href: string) =>
  packagesData.find((item) => item.href === href);
